import React from 'react';
import c from 'classnames';
import Dumbo, { DumboProps } from '../Dumbo';
import PremiumIcon from '../Helper/PremiumIcon';

import s from './DumboWithIcon.scss';

// The icon is shown on premium deviations

export const DumboWithIcon: React.FC<DumboProps> = ({
  className,
  ...props
}) => {
  return (
    <div className={c(s['root'], className)}>
      <Dumbo {...props} />
      <PremiumIcon
        className={s['icon']}
        premiumFolderData={props.deviation.premiumFolderData}
        tooltipClassName={s['tooltip']}
      />
    </div>
  );
};
DumboWithIcon.displayName = 'DumboWithIcon';

export default DumboWithIcon;
